/** Passo "redondo" ≥ `raw`: 1, 2, 2,5, 5, 7,5 ou 10 × 10ⁿ. */
export function niceStep(raw: number): number {
  if (!(raw > 0)) return 1;
  const mag = 10 ** Math.floor(Math.log10(raw));
  const f = raw / mag;
  const nice = [1, 2, 2.5, 5, 7.5, 10].find((n) => f <= n + 1e-9) ?? 10;
  return nice * mag;
}

/** Ticks de 0 até o primeiro múltiplo do passo ≥ `max` (`count` intervalos). Ex.: 2750, 4 → 0…3000 de 750 em 750. */
export function linearTicks(max: number, count = 4): number[] {
  const step = niceStep(max / count);
  const top = Math.max(step * count, Math.ceil(max / step) * step);
  const n = Math.round(top / step);
  return Array.from({ length: n + 1 }, (_, i) => i * step);
}

/** Mapeia `v` de [0, max] para [bottom, top] (SVG: y cresce para baixo). */
export const scaleY = (v: number, max: number, top: number, bottom: number) => (max > 0 ? bottom - (v / max) * (bottom - top) : bottom);

/** Altura de barra arredondada em px, proporcional ao maior valor. */
export const barHeight = (v: number, max: number, height: number) => (max > 0 ? Math.round((v / max) * height) : 0);

/** Fração 0–1 limitada. */
export const clamp01 = (v: number) => Math.min(1, Math.max(0, Number.isFinite(v) ? v : 0));

export const f1 = (n: number) => n.toFixed(1);

/** Curva suave (Catmull-Rom com tensão), no formato do SVG do pacote. */
export function smoothPath(pts: [number, number][], tension = 0.16): string {
  if (!pts.length) return '';
  let d = `M${f1(pts[0][0])},${f1(pts[0][1])}`;
  for (let i = 0; i < pts.length - 1; i++) {
    const p0 = pts[i - 1] ?? pts[i];
    const p1 = pts[i];
    const p2 = pts[i + 1];
    const p3 = pts[i + 2] ?? p2;
    const c1 = [p1[0] + (p2[0] - p0[0]) * tension, p1[1] + (p2[1] - p0[1]) * tension];
    const c2 = [p2[0] - (p3[0] - p1[0]) * tension, p2[1] - (p3[1] - p1[1]) * tension];
    d += ` C${f1(c1[0])},${f1(c1[1])} ${f1(c2[0])},${f1(c2[1])} ${f1(p2[0])},${f1(p2[1])}`;
  }
  return d;
}
